(function () {
    'use strict';


    angular.module('swif.ui')
    .directive('swifMinDatetime', swifMinDatetime)
    .directive('swifMaxDatetime', swifMaxDatetime)
    .directive('swifMinDate', swifMinDate)
    .directive('swifMaxDate', swifMaxDate);


    /**
    * @ngdoc directive
    * @name swif.ui:swifMinDatetime
    * @module swif.ui
    * @restrict A
    * @description
    **/
    function swifMinDatetime(swifFormUtility) {
        'ngInject';
        return {
            restrict: 'A',
            scope: {
                minDatetime: '=?swifMinDatetime',
            },
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                swifFormUtility.addMinDatetimeSupport(scope, element, attr, ngModel);
            }
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifMaxDatetime
    * @module swif.ui
    * @restrict A
    * @description
    **/
    function swifMaxDatetime(swifFormUtility) {
        'ngInject';
        return {
            restrict: 'A',
            scope: {
                maxDatetime: '=?swifMaxDatetime',
            },
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                swifFormUtility.addMaxDatetimeSupport(scope, element, attr, ngModel);
            }
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifMinDate
    * @module swif.ui
    * @restrict A
    * @description
    **/
    function swifMinDate(swifFormUtility) {
        'ngInject';
        return {
            restrict: 'A',
            scope: {
                minDate: '=?swifMinDate',
            },
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                swifFormUtility.addMinDateSupport(scope, element, attr, ngModel);
            }
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifMaxDate
    * @module swif.ui
    * @restrict A
    * @description
    **/
    function swifMaxDate(swifFormUtility) {
        'ngInject';
        return {
            restrict: 'A',
            scope: {
                minDate: '=?swifMaxDate',
            },
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                swifFormUtility.addMaxDateSupport(scope, element, attr, ngModel);
            }
        };
    }



})();
